import styled from "@emotion/styled";

export const PromoModalWrapper = styled.div(({}) => {
  return {
    "& .MuiDialogContentText-root": {
      marginTop: 0,
    },
  };
});
